import { IProfileApiModel, ITicketApiModel } from './api';
import { DealModel } from './deal.model';
import { PlaceModel } from './place.model';
import { TicketModel } from './ticket.model';

export class ProfileModel {
  nSubscribers: number;
  nPlaces: number;
  nPlacesOwned: number;
  nPlacesLiked: number;
  nBookmarks: number;
  nHistory: number;
  reputation: number;
  reputationTitle: string;
  reputationStyle: IProfileApiModel['reputation_style'];
  cityName: string;
  isTop: boolean;
  phone: string;

  private _deals: IProfileApiModel['coupons'];
  private _tickets: IProfileApiModel['tickets'];
  private _bookmarks: IProfileApiModel['bookmarks'];

  get deals(): Array<DealModel> {
    return this._deals ? this._deals.map(item => new DealModel(item)) : [];
  }

  get tickets(): Array<TicketModel> {
    return this._tickets
      ? this._tickets.map(item => new TicketModel(item))
      : [];
  }

  get bookmarks(): Array<PlaceModel> {
    return this._bookmarks
      ? this._bookmarks.map(item => new PlaceModel(item))
      : [];
  }

  constructor(source?: IProfileApiModel) {
    if (source == null) {
      return;
    }
    this.nSubscribers = source.c_subscribers;
    this.nPlaces = source.c_beacons;
    this.nPlacesOwned = source.c_beacons_owned;
    this.nPlacesLiked = source.c_beacons_liked;
    this.nBookmarks = source.c_bookmarks;
    this.nHistory = source.c_history;
    this.reputation = source.reputation;
    this.reputationTitle = source.reputation_title;
    this.reputationStyle = source.reputation_style;
    this.cityName = source.city_name;
    this.isTop = source.is_top;
    this.phone = source.phone;

    this._deals = source.coupons;
    this._tickets = source.tickets;
    this._bookmarks = source.bookmarks;
  }

  static copyObj(source: Pick<ProfileModel, keyof ProfileModel>): ProfileModel {
    return Object.assign(new ProfileModel(), source);
  }

  setNewTicketCheck(check_id: string, beacon_id: number): void {
    this._tickets = this._tickets?.map(ticket => {
      ticket.statuses.map(status => {
        if (status.check_id === check_id) {
          status.verifications.push({
            date: new Date().toISOString(),
            beacon_id: beacon_id,
          });
        }
      });
      return ticket;
    });
  }
}
